export const CROSS_SELL_TEST_IDS = {
    PILL_CONTAINER: "PILL_CONTAINER",
    ITEM_NAME: "ITEM_NAME",
    ITEM_IMAGE: "ITEM_IMAGE",
    ITEM_BASE_PRICE: "ITEM_BASE_PRICE",
    ITEM_PRICE: "ITEM_PRICE",
    ADD_BUTTON: "ADD_BUTTON",
    ITEM_DETAILS: "ITEM_DETAILS",
    ALL_ITEMS_ADDED_CONTAINER: "ALL_ITEMS_ADDED_CONTAINER",
    CAROUSEL_CONTAINER: "CAROUSEL_CONTAINER",
    HALF_CARD_CONTAINER: "HALF_CARD_CONTAINER",
    ITEM_DETAILS_ITEM_NAME: "ITEM_DETAILS_ITEM_NAME",
    ITEM_DETAILS_ITEM_IMAGE: "ITEM_DETAILS_ITEM_IMAGE",
    ITEM_DETAILS_ITEM_PRICE: "ITEM_DETAILS_ITEM_PRICE",
    ITEM_DETAILS_ITEM_DESCRIPTION: "ITEM_DETAILS_ITEM_DESCRIPTION",
};
